import React from 'react'
import styled, { keyframes } from 'styled-components'
import { TweenLite, TimelineMax } from "gsap"
import { Howl } from 'howler/src/howler.core'

// page elements
import Header from '@components/header'
import VideoPlayer from '@components/home/VideoPlayer'

class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      theme: `dark`
    }
  }

  timelineUpdate() {
    this.setState({
      theme: this.timeline.currentLabel() === null ? 'dark' : this.timeline.currentLabel()
    })
  }

  render() {

    return (
      <React.Fragment>

        <Header theme={this.state.theme} />

        {/* background video */}
        <VideoPlayer theme={this.state.theme} />

      </React.Fragment>
    )
  }
}

export default Home;